const locale = {
  // Applications: 'Модули',
  Applications: 'Заявления',
  HR: 'HR',
  ADMIN: 'АДМИНИСТРАТОР',
  EXAMPLE: 'Пример',
  Academy: 'Курсы',
  Profile: 'Профиль',
  Continue: 'Продолжить',
  Settings: 'Настройки',
  Export: 'Экпорт',
  CompanyNews: 'Новости компании',
  Employees: 'Сотрудники',
  Chat: 'Чат',
  Mail: 'Почта',
  ProjectsManagement: 'Управление проектами',
  Projects: 'Проекты',
  Contracts: 'Контракты',
  Structure: 'Орг. структура',
  Blanks: 'Бланки заявлений',
  Skud: 'Учет рабочего времени',
  SkudEmployees: 'Подчинённые',
  MySkud: 'Моё время',
  Departments: 'Департаменты',
  Users: 'Пользователи',
  Roles: 'Роли',
  StaffTable: 'Штатное расписание',
  References: 'Справочники',
  Companies: 'Компании',
  Positions: 'Должности',
  HelpDesk: 'Служба поддержки',
  SkudReport: 'СКУД. Статистика',
  Calendar: 'Календарь',
  ResourcesCalendar: 'Календарь ресурсов',
  MyCalendar: 'Мой календарь',
  Reservation: 'Бронирование',
  Support: 'Поддержка',
  Presentations: 'Презентации',
  Main: 'Главная',
  Basic: 'Основное',
  Work: 'Работа',
  Useful: 'Полезное',
  Administration: 'Администрирование',
  HumanResources: 'Работа с персоналом',
  HelpCenter: 'Центр помощи',
  Feedback: 'Обратная связь',
  Documents: 'Документы',
  MyUzinfocom: 'Мой Uzinfocom',
  Map: 'Карта',
  Maps: 'Карты',
  DownloadApp: 'Скачать приложение',
  Logs: 'Логи',
  ClaimExecutors: 'Исполнители заявок',
  ClaimsProcessing: 'Обработка заявок',
  InternalDocuments: 'Внутренние документы',
  Claims: 'Заявки',
  DailyAttendances: 'Посещения за день',
  AbsenceAsks: 'Рабочие выезды и отгулы',
  UsefulLinks: 'Полезные ссылки',
  Workload: 'Загруженность',
  TopManagers: 'Руководство',
  Appointments: 'Записи на приём',
  VideoConferences: 'Видеоконференции',
  Values: 'Ценности',
  MemoryAndHonors: 'Память и почести',
  Skills: 'Навыки',
  Faithful: 'Люди история',
  ElectronMail: 'Электронная почта',
  MyUzAtom: 'Мой UzAtom',
  TemplatesConstructor: 'Конструктор шаблонов',
  TemplatesManagement: 'Управление шаблонами',
  IncomingDocuments: 'Входящие документы',
  Executed: 'Выполнены',
  PendingExecution: 'В ожидании',
  InExecution: 'На исполнении',
  MyApplications: 'Мои заявления',
  Staff: 'Сотрудники',
  PrintDocuments: 'Печать документов',
  DocumentTemplateExecutors: 'Исполнители шаблонов документов',
  DocumentExecutors: 'Исполнители документов',
  Report: 'Отчёт',
  ProjectsManagement: 'Управление проектами',
  MyDocuments: 'Мои документы',
  DepartmentsReport: 'Отчёт за месяц',
  Fulfilled: 'Исполненные',
  DocumentChecking: 'Проверка документа',
  Dashboard: 'Дашборд',
  MyDrive: 'Мой диск',
  ServiceDesk: 'Техническая поддержка',
  BlocksDailyReport: 'Отчёт по блокам за сутки',
  SkudStatistics: 'СКУД. Статистика',
  PendingSignature: 'На подписи',
  Signed: 'Подписанные',
  Rejected: 'Отклонённые',
  Archived: 'Архивированные',
  Archive: 'Архив',
  LocalNormativeActs: 'Локальные нормативные акты',
  InternalWorkflow: 'Внутренний документооборот',
  AttendaceReport: 'Отчёт о посещаемости',
  InternalWorkflow2: 'Внутренний документооборот(2)',
  AttendaceReportTop: 'Отчет по посещаемости ТОП-менеджмента',
  MyCalendarBeta: 'Мой календарь (beta)',
  OutgoingDocuments: 'Исходящие документы',
  CreateDocument: 'Создать документ',
  AttendanceReport: 'Отчёт о посещаемости',
};

export default locale;
